import React from "react";
import { logoTokens } from "./tokens";

// VImplement mark — "V" framed by code brackets (monoline). Transparent so it
// sits on light or dark surfaces; colours switch with `tone`.
export default function LogoMark({
  size = 36,
  title = logoTokens.brandName,
  decorative = false,
  tone = "light",
  className,
  style,
}) {
  const { mark } = logoTokens;
  const t = tone === "dark" ? "dark" : "light";
  const bracketColor = mark.bracket[t] ?? mark.bracket.light;
  const vColor = mark.vColor[t] ?? mark.vColor.light;

  const accessibility = decorative
    ? { "aria-hidden": true, focusable: "false" }
    : { role: "img", "aria-label": title };

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={mark.viewBox}
      className={className}
      style={style}
      {...accessibility}
    >
      <g fill="none" strokeLinecap="round" strokeLinejoin="round">
        <polyline points={mark.leftBracket} stroke={bracketColor} strokeWidth={mark.strokeWidth} />
        <polyline points={mark.rightBracket} stroke={bracketColor} strokeWidth={mark.strokeWidth} />
        <polyline points={mark.vPoints} stroke={vColor} strokeWidth={mark.vStrokeWidth} />
      </g>
    </svg>
  );
}
